// extracted by mini-css-extract-plugin
module.exports = {"spinner":"ChartSpinner_spinner__1kHz9"};